import { components } from 'react-select';

import { PlaceholderProps } from './Placeholder.types';
import { useStyles } from './Placeholder.styles';

export const Placeholder = ({ children, ...rest }: PlaceholderProps) => {
  const styles = useStyles();

  return (
    <components.Placeholder css={styles.root} {...rest}>
      {children}
    </components.Placeholder>
  );
};
